import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { NetworkCallService } from '../../../../src/app/core/services/network-call.service';
import * as actions from '../actions/tax-numbers.actions';
import { ITaxNumbersResponse, ITaxNumber, ITaxNumberSaveResponse } from '../models/tax-numbers.model';
import { HelpersService } from '../../core/services/helpers.service';
import { Store } from '@ngrx/store';

@Injectable()
export class TaxNumbersEffects {
  constructor(
    private actions$: Actions,
    private readonly networkCallService: NetworkCallService,
    private helpers: HelpersService,
    private store: Store
  ) {}

  loadTaxNumbers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.loadTaxNumbers),
      switchMap(action => {
        return this.networkCallService
          .get<ITaxNumbersResponse>(
            `CustomerAdmin/${action.customerId}/TaxNumbers`
          )
          .pipe(
            map((response: ITaxNumbersResponse) => actions.loadTaxNumbersSuccess({ response })),
            catchError(error => {
              return of(actions.loadTaxNumbersFailure({ error }));
            })
          );
      })
    );
  });

  saveTaxNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.saveTaxNumber),
      switchMap(action =>
        this.networkCallService
          .put<ITaxNumber, ITaxNumberSaveResponse>(
            `CustomerAdmin/${action.customerId}/TaxNumber/${action.taxNumber.userProfileTaxNumberId}`,
            action.taxNumber
          )
          .pipe(
            map(response => {
              this.helpers.notifySuccess('Tax number saved successfully', 300, 2500);
              this.store.dispatch(actions.loadTaxNumbers({ customerId: action.customerId }));
              return actions.saveTaxNumberSuccess({ response });
            }),
            catchError(error => {
              return of(actions.saveTaxNumberFailure({ error }));
            })
          )
      )
    )
  );
}